import {
  FsTournamentDriver,
  FsTournamentDriverRoster,
  FsTournamentSquadRoster,
} from "db/model/tournament/FsTournamentRoster";
import {
  TournamentDriver,
  TournamentDriverRoster,
  TournamentSquadRoster,
} from "model/Roster/TournamentRoster";
import { mapMultiple } from "../Utility";

export const mapTournamentDriverRoster = (
  fsModel: FsTournamentDriverRoster
): TournamentDriverRoster | undefined => {
  if (!fsModel.id) {
    return undefined;
  }

  return {
    id: fsModel.id,
    name: fsModel.name,
    orgId: fsModel.orgId,
    orgName: fsModel.orgName,
  };
};

const mapTournamentDriver = (
  fsModel: FsTournamentDriver
): TournamentDriver | undefined => {
  if (!fsModel.id) {
    return undefined;
  }

  return {
    id: fsModel.id,
    name: fsModel.name,
  };
};

export const mapTournamentSquadRoster = (
  fsModel: FsTournamentSquadRoster
): TournamentSquadRoster | undefined => {
  if (!fsModel.id) {
    return undefined;
  }

  return {
    id: fsModel.id,
    drivers: mapMultiple(fsModel.drivers, mapTournamentDriver) ?? [],
    name: fsModel.name,
    orgId: fsModel.orgId,
    orgName: fsModel.orgName,
    trigram: fsModel.trigram,
  };
};
